module.exports = __webpack_public_path__ + "media/src/images/top_covers/xmas_image_01-ecaa2777013b40cabee9bab5628005de.png";